import { ONE_HOUR, ONE_MINUTE } from '../../tools/utils';
export var SESSION_TIME_OUT_DELAY = 4 * ONE_HOUR;
export var SESSION_EXPIRATION_DELAY = 15 * ONE_MINUTE;
//# sourceMappingURL=sessionConstants.js.map